/*
PURPOSE: Small inline SVG "tick badge" — solid circle + white check. Replaces
the legacy added-artist.png so the shape scales as vector and the colour is
themed via Tailwind currentColor.
USE CASES:
- AllInOneCoralCreator: indicates an artist is already added to the coral
  (uses editorial-accent in editorial mode, coral-pink on platform pages).
- MiniArtistTable (platform): doubles as the "remove" affordance on platform
  pages (uses coral-pink).
DOMAIN BOUNDARIES:
- Presentation only. The badge has no semantics beyond what the caller
  passes via aria-label.
- The circle uses fill="currentColor" so the colour comes from the parent's
  Tailwind text-* utility (text-editorial-accent / text-coral-pink / …).
*/

import React from 'react';

interface AddedTickProps {
  /** Tailwind text-color class (drives the circle fill via currentColor). */
  colorClassName?: string;
  /** Tailwind size class. */
  sizeClassName?: string;
  /** Accessible label for SR / agent users. */
  ariaLabel?: string;
}

const AddedTick: React.FC<AddedTickProps> = ({
  colorClassName = 'text-coral-pink',
  sizeClassName = 'w-5 h-5',
  ariaLabel = 'Artist added',
}) => (
  <svg
    viewBox="0 0 20 20"
    className={`${sizeClassName} ${colorClassName}`}
    aria-label={ariaLabel}
    role="img"
  >
    <circle cx="10" cy="10" r="10" fill="currentColor" />
    <path
      d="M6 10.5 L9 13.5 L14.5 7.5"
      stroke="white"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default AddedTick;
